import { useTranslation } from 'react-i18next';
import { Flex } from 'antd';
import WarningImage from 'pos-client/assets/Avayler-Car-Warning.png';
import { PosPage } from 'pos-client/layouts/page/PosPage.tsx';

interface BoundaryErrorProps {
  image?: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  buttonOnClick?: () => void;
  hideToolbar?: boolean;
}

export const BoundaryError = ({
  image,
  title,
  description,
  buttonLabel,
  buttonOnClick,
  hideToolbar,
}: BoundaryErrorProps) => {
  const { t } = useTranslation();

  const errorImage = image ?? WarningImage;
  const errorTitle = title ?? t('httpStatus.500');
  const errorButtonLabel =
    buttonLabel ?? `${t('common.buttons.go')} ${t('common.buttons.home')}`;
  const errorButtonOnClick = () => {
    if (buttonOnClick) {
      buttonOnClick();
    } else {
      window.location.assign('/');
    }
  };

  return (
    <PosPage styles={{ root: { width: '100%' } }} hideToolbar={hideToolbar}>
      <Flex justify="center" align="center" vertical style={{ height: '100%' }}>
        <img src={errorImage} height={250} />
        <h2 style={{ marginTop: 5, marginBottom: 15, fontWeight: 'bold' }}>
          {errorTitle}
        </h2>
        {description && <p>{description}</p>}
        <button
          onClick={errorButtonOnClick}
          style={{
            background: '#00005d',
            color: 'white',
            height: '32px',
            padding: '4px 15px',
            borderRadius: '6px',
            fontWeight: '400',
            border: '0',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          {errorButtonLabel}
        </button>
      </Flex>
    </PosPage>
  );
};
